<script lang="ts">
  import ChatCard from "../components/ChatCard.svelte"
  import Button from "../../component_library/components/svelte/Button.svelte"
  import Svg from "../components/Svg.svelte"
  import ArrowBack from "../Icons/arrow_back.svg?raw"
  import { getContext } from "svelte"
  import type { Theme } from "website_script/types/theme"
  import type { Texts } from "website_script/types/texts"
  import type { PromptComponentOnModalTriggerFunc } from "./types"

  const { textCtaColor, promptButtonColor } = getContext<Theme>("theme")
  const { testDrivePromptMessage, promptSender, testDrivePromptCta } =
    getContext<Texts>("texts")

  /** Handle triggering of modal when user interacts */
  export let onModalTrigger: PromptComponentOnModalTriggerFunc

  /**
   * Opens the modal
   */
  const buttonClickHandler = () => {
    onModalTrigger({ source: "Test Drive Prompt" })
  }
</script>

<!--
@component

This shows a small card that can be used for prompting the users to book a test drive
-->
<div data-testid="test-drive-prompt" class="auws-test-drive-prompt">
  <ChatCard message={testDrivePromptMessage} sender={promptSender}>
    <div slot="call-to-action">
      <Button
        extraClasses="auws-test-drive-button"
        clickHandler={buttonClickHandler}
        style={`background-color: ${promptButtonColor}; color: ${textCtaColor};`}
      >
        {testDrivePromptCta}
        <Svg
          data={ArrowBack}
          color={textCtaColor}
          size="24px"
          alt="Action arrow"
        />
      </Button>
    </div>
  </ChatCard>
</div>

<style>
  .auws-test-drive-prompt :global(.auws-test-drive-button) {
    width: 100%;
    border-radius: 4px;
    font-size: 14px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding-left: 25px;
    padding-right: 25px;
  }
</style>
